  (function () {

    // ── Finish effect functions (same as b2b_upload_customizer.js) ───────────
    function applyMetallicEffect(dataUrl, callback) {
      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = img.width; canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var d = ctx.getImageData(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < d.data.length; i += 4) {
          if (d.data[i + 3] > 0) {
            var lum = d.data[i] * 0.299 + d.data[i + 1] * 0.587 + d.data[i + 2] * 0.114;
            d.data[i + 3] = Math.round((1 - lum / 255) * d.data[i + 3]);
          }
        }
        ctx.putImageData(d, 0, 0);
        ctx.globalCompositeOperation = 'source-atop';
        var grad = ctx.createLinearGradient(0, 0, canvas.width * 0.85, canvas.height);
        grad.addColorStop(0,    '#5a5a5a');
        grad.addColorStop(0.25, '#adadad');
        grad.addColorStop(0.45, '#e8e8e8');
        grad.addColorStop(0.55, '#ffffff');
        grad.addColorStop(0.75, '#c0c0c0');
        grad.addColorStop(1,    '#646464');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        callback(canvas.toDataURL('image/png'));
      };
      img.src = dataUrl;
    }

    function applyUVEffect(dataUrl, mimeType, callback) {
      if (mimeType === 'image/svg+xml') { callback(dataUrl); return; }
      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = img.width; canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var d = ctx.getImageData(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < d.data.length; i += 4) {
          if (d.data[i] > 220 && d.data[i + 1] > 220 && d.data[i + 2] > 220) { d.data[i + 3] = 0; }
        }
        ctx.putImageData(d, 0, 0);
        callback(canvas.toDataURL('image/png'));
      };
      img.src = dataUrl;
    }

    function renderFinishPreview(slot) {
      var logo = studioLogos[slot];
      var wrap = document.querySelector('.cbv3-finish-preview[data-slot="' + slot + '"]');
      if (!wrap) return;
      var canvas  = wrap.querySelector('.cbv3-finish-preview__canvas');
      var empty   = wrap.querySelector('.cbv3-finish-preview__empty');
      var finBtn  = document.querySelector('.cbv3-finish-btn.is-selected');
      var finish  = finBtn ? finBtn.dataset.finish : 'uv';

      if (!logo) {
        canvas.style.display = 'none';
        empty.style.display  = '';
        return;
      }

      function drawToCanvas(processedUrl) {
        var img = new Image();
        img.onload = function () {
          canvas.width  = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          canvas.style.display = 'block';
          empty.style.display  = 'none';
        };
        img.src = processedUrl;
      }

      if (finish === 'metallic') {
        logo.mimeType === 'image/svg+xml'
          ? drawToCanvas(logo.dataUrl)
          : applyMetallicEffect(logo.dataUrl, drawToCanvas);
      } else {
        applyUVEffect(logo.dataUrl, logo.mimeType, drawToCanvas);
      }
    }

    function renderAllFinishPreviews() {
      renderFinishPreview('a');
      renderFinishPreview('b');
    }

    // ── Logo uploaders ────────────────────────────────────────────────────────
    // Files buyers can upload (Kegan, 4 Oct 2026: take the sale, our team checks
    // the file and emails if it needs work). PNG, JPG and SVG preview on the
    // product; PDF, AI and EPS cannot be drawn by a browser, so they show a
    // placeholder, get no composed mockup, and go to the Worker untouched.
    var MB = 1024 * 1024;
    var FILE_KINDS = {
      png: { maxBytes: 5 * MB,  preview: true },
      jpg: { maxBytes: 5 * MB,  preview: true },
      svg: { maxBytes: 5 * MB,  preview: true },
      pdf: { maxBytes: 20 * MB, preview: false },
      ai:  { maxBytes: 20 * MB, preview: false },
      eps: { maxBytes: 20 * MB, preview: false }
    };
    var FILE_ACCEPT = '.png,.jpg,.jpeg,.svg,.pdf,.ai,.eps';
    var FILE_NOTE   = 'Our team checks your file and emails you if it needs work.';
    var studioLogos = { a: null, b: null }; // { filename, dataUrl, cdnUrl, mimeType, previewable, kind }

    // The file's own extension first (browsers report AI as application/pdf,
    // application/postscript or nothing), then its MIME type.
    function fileKind(file) {
      var ext = String((file && file.name) || '').split('.').pop().toLowerCase();
      if (ext === 'jpeg') ext = 'jpg';
      if (FILE_KINDS[ext]) return ext;
      var t = String((file && file.type) || '').toLowerCase();
      if (t === 'image/png') return 'png';
      if (t === 'image/jpeg') return 'jpg';
      if (t === 'image/svg+xml') return 'svg';
      if (t === 'application/pdf') return 'pdf';
      if (t.indexOf('illustrator') !== -1) return 'ai';
      if (t === 'application/postscript' || t.indexOf('eps') !== -1) return 'eps';
      return '';
    }

    // Stand-in picture for a PDF, AI or EPS: ink #262626 on #FFFFFF (15.1:1).
    // Typed as SVG so the laser/UV preview effects leave it alone.
    function placeholderFor(kind) {
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="260" viewBox="0 0 400 260">' +
        '<rect x="4" y="4" width="392" height="252" rx="18" fill="#FFFFFF" stroke="#262626" stroke-width="6" stroke-dasharray="18 12"/>' +
        '<path d="M172 46h40l26 26v84h-66z" fill="none" stroke="#262626" stroke-width="8" stroke-linejoin="round"/>' +
        '<path d="M212 46v26h26" fill="none" stroke="#262626" stroke-width="8" stroke-linejoin="round"/>' +
        '<text x="200" y="218" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="42" font-weight="700" fill="#262626">' +
        String(kind || 'logo').toUpperCase() + ' file</text></svg>';
      return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    }

    // One id per studio page load. Embedded in every uploaded filename so the
    // CDN/resolver URL that ends up on the order is traceable back to this
    // session without guessing by upload timestamp (see fileCreate polling
    // fallback in the Worker — same id makes filenames collision-free too).
    var studioSessionId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var UPLOAD_TIMEOUT_MS = 120000;
    var uploadSeq = 0;

    // A short random id per upload on top of the session id: re-uploading Logo A,
    // or composing a second preview for the same side, used to reuse the exact
    // filename, and the Worker's slow-path resolver looks files up by name.
    function uploadId() { return studioSessionId + '-' + Math.random().toString(36).slice(2, 6); }

    function buildLogoFilename(originalName, slot, kind) {
      var ext     = kind || originalName.split('.').pop().toLowerCase();
      var company = (window.b2bCompanyName || 'studio').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var date    = new Date().toISOString().slice(0, 10);
      return [company, date, 'logo-' + slot, uploadId()].join('_') + '.' + ext;
    }

    function buildPreviewFilename(side) {
      var company = (window.b2bCompanyName || 'studio').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var date    = new Date().toISOString().slice(0, 10);
      return [company, date, 'preview-' + side, uploadId()].join('_') + '.png';
    }

    // A logo link that can go on an order: https from the Worker, never a bare
    // filename (what a failed upload used to leave in B2B <ZONE> IMAGE).
    function isUsableUrl(u) {
      return typeof u === 'string' && /^https:\/\/\S+$/i.test(u.trim());
    }

    // POST to the upload Worker. Resolves with the https link, or rejects on a
    // non-2xx, an {error} reply, a reply without a link, a network error or a
    // timeout. Every logo and preview upload goes through here.
    function postToWorker(filename, dataUrl, expectExt) {
      var workerUrl = window.b2bUploadWorkerUrl;
      if (!workerUrl) { return Promise.reject(new Error('no-worker')); }
      var ctl   = window.AbortController ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, UPLOAD_TIMEOUT_MS) : null;
      return fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: filename, dataUrl: dataUrl }),
        signal: ctl ? ctl.signal : undefined
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (json) {
            if (!r.ok || json.error) { throw new Error(json.error || 'worker-' + r.status); }
            if (!isUsableUrl(json.url)) { throw new Error('no-url'); }
            // A PDF, AI or EPS must come back with its own extension. An older
            // Worker renamed AI/EPS to .png (a file Shopify cannot process).
            if (expectExt && !new RegExp('\\.' + expectExt + '$', 'i').test(json.url.trim().split('?')[0])) {
              throw new Error('wrong-type');
            }
            return json.url.trim();
          });
        })
        .then(function (url) { if (timer) clearTimeout(timer); return url; },
              function (err) { if (timer) clearTimeout(timer); throw err; });
    }

    function uploaderSetState(uploader, state) {
      uploader.querySelectorAll('.cbv3-upload-state').forEach(function (el) { el.classList.remove('is-active'); });
      var target = uploader.querySelector('.cbv3-upload-state--' + state);
      if (target) target.classList.add('is-active');
      uploader.classList.toggle('has-file', state === 'ready');
    }

    function initUploader(uploader) {
      var slot    = uploader.dataset.slot;
      var input   = uploader.querySelector('.cbv3-file-input');
      var zoneBtn = uploader.querySelector('.cbv3-upload-zone-btn');
      var preview = uploader.querySelector('.cbv3-upload-preview');
      var fnEl    = uploader.querySelector('.cbv3-upload-filename');
      var errEl   = uploader.querySelector('.cbv3-upload-error-msg');
      input.setAttribute('accept', FILE_ACCEPT);
      var noteEl  = document.createElement('p');
      noteEl.className = 'cbv3-upload-note';
      noteEl.textContent = FILE_NOTE;
      noteEl.hidden = true;
      fnEl.parentNode.insertBefore(noteEl, fnEl.nextSibling);

      function showError(msg) {
        noteEl.hidden = true;
        errEl.textContent = msg;
        uploaderSetState(uploader, 'error');
        studioLogos[slot] = null;
        input.value = '';
        updateLogoStrip();
        updateTabCompletion();
        var _activeCard = document.querySelector('.cbv3-card.is-active');
        if (_activeCard) positionBoundary(_activeCard);
      }

      function handleFile(file) {
        if (!file) return;
        var kind = fileKind(file);
        if (!kind) { showError('That file type cannot be used. Upload a PNG, JPG, SVG, PDF, AI or EPS file.'); return; }
        if (file.size > FILE_KINDS[kind].maxBytes) {
          showError(FILE_KINDS[kind].preview
            ? 'That file is over 5 MB. PNG, JPG and SVG files can be up to 5 MB.'
            : 'That file is over 20 MB. PDF, AI and EPS files can be up to 20 MB.');
          return;
        }
        var previewable = FILE_KINDS[kind].preview;

        uploaderSetState(uploader, 'uploading');
        studioLogos[slot] = null; // nothing from this slot is usable until the upload lands
        updateLogoStrip();
        updateTabCompletion();
        var builtName = buildLogoFilename(file.name, slot, kind);
        var token = ++uploadSeq;
        uploader._uploadToken = token; // a newer file or Remove makes this upload stale
        var reader = new FileReader();
        reader.onerror = function () {
          if (uploader._uploadToken === token) showError('We could not read that file. Please try again.');
        };
        reader.onload = function (e) {
          if (uploader._uploadToken !== token) return;
          var dataUrl = e.target.result;

          function onReady(cdnUrl) {
            // PDF/AI/EPS: everything on screen uses the placeholder; the
            // original file is already on the Worker (cdnUrl)
            var shown = previewable ? dataUrl : placeholderFor(kind);
            studioLogos[slot] = { filename: builtName, dataUrl: shown, cdnUrl: cdnUrl,
                                  mimeType: previewable ? file.type : 'image/svg+xml', previewable: previewable, kind: kind };
            renderFinishPreview(slot);
            fnEl.textContent = builtName;
            noteEl.hidden = previewable;
            preview.src = shown;
            preview.style.display = '';
            uploaderSetState(uploader, 'ready');
            updateLogoStrip();
            updateTabCompletion();
            var _activeCard = document.querySelector('.cbv3-card.is-active');
            if (_activeCard) positionBoundary(_activeCard);
          }

          // A failed upload used to call onReady('') and look "ready" while the
          // order got a bare filename. Now it is an error with Try Again, and the
          // slot stays empty so it cannot be assigned or sent to the cart.
          postToWorker(builtName, dataUrl, previewable ? '' : kind)
            .then(function (url) {
              if (uploader._uploadToken !== token) return;
              onReady(url);
            })
            .catch(function (err) {
              if (uploader._uploadToken !== token) return;
              var why = err && err.name === 'AbortError'
                ? 'The upload took too long. Check your connection, then tap Try Again.'
                : err && err.message === 'no-worker'
                  ? 'Uploads are not working right now. Please try again in a few minutes.'
                  : err && err.message === 'wrong-type'
                    ? "We couldn't take that file type just now. Please upload it as a PNG, JPG, SVG or PDF."
                    : "Your logo didn't upload, so it can't be used yet. Tap Try Again.";
              showError(why);
            });
        };
        reader.readAsDataURL(file);
      }

      zoneBtn.addEventListener('click', function () { input.click(); });
      input.addEventListener('change', function () { handleFile(this.files[0]); });

      uploader.querySelector('.cbv3-upload-remove').addEventListener('click', function (e) {
        e.stopPropagation();
        uploader._uploadToken = 0;
        noteEl.hidden = true;
        studioLogos[slot] = null;
        input.value = '';
        preview.src = '';
        uploaderSetState(uploader, 'init');
        renderFinishPreview(slot);
        updateLogoStrip();
        updateTabCompletion();
        var _activeCard = document.querySelector('.cbv3-card.is-active');
        if (_activeCard) positionBoundary(_activeCard);
      });

      uploader.querySelector('.cbv3-upload-retry').addEventListener('click', function () {
        uploaderSetState(uploader, 'init');
      });

      uploader.addEventListener('dragover', function (e) { e.preventDefault(); uploader.classList.add('is-dragover'); });
      uploader.addEventListener('dragleave', function ()  { uploader.classList.remove('is-dragover'); });
      uploader.addEventListener('drop', function (e) {
        e.preventDefault();
        uploader.classList.remove('is-dragover');
        handleFile(e.dataTransfer.files[0]);
      });
    }

    document.querySelectorAll('.cbv3-uploader').forEach(initUploader);

    // ── Boundary dims (same ratios as b2b_upload_customizer.js) ──────────────
    var BOTTLE_DIMS = {
      '950ml':  { w: 0.143, t: 0.370, h: 0.231 }, // 1L
      '1-9l':   { w: 0.138, t: 0.413, h: 0.199 }, // 2L
      'stubby': { w: 0.209, t: 0.206, h: 0.479 }, // Stubby
      '4l':     { w: 0.20, t: 0.415, h: 0.325 }, // 4L — aligned with customizer-dtc.js AREA_RATIOS
      '6l':     { w: 0.20, t: 0.33125, h: 0.4125 }, // 6L — aligned with customizer-dtc.js AREA_RATIOS
      'wine':   { w: 0.166, t: 0.530, h: 0.390 }  // Wine
    };
    var BAG_DIMS = {
      '20lbag':  { front: { w: 0.2256,  t: 0.2,    h: 0.1175          }, back: { w: 0.155,    t: 0.45,   h: 0.3             } },
      '35lbag':  { front: { w: 0.2375,  t: 0.175,  h: 0.1175, l: 0.35 }, back: { w: 0.20125,  t: 0.425,  h: 0.2825, l: 0.375 } },
      '15lbag':  { back:  { w: 0.2113,  t: 0.7875, h: 0.10            } },
      'ridepal': { front: { w: 0.2586,  t: 0.4828, h: 0.1379, l: 0.3793 } },
      'lunchpal':{ front: { w: 0.2375,  t: 0.25,   h: 0.1175          } }
    };
    var BAG_TAGS = ['20lbag','35lbag','15lbag','ridepal','lunchpal'];

    function getImgContent(img) {
      var ew = img.clientWidth, eh = img.clientHeight;
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) return null;
      var scale = Math.min(ew / nw, eh / nh);
      var iw = nw * scale, ih = nh * scale;
      return { left: (ew - iw) / 2, top: (eh - ih) / 2, width: iw, height: ih };
    }

    function positionOverlay(card, zoneKey, overlay, bl, bt, bw, bh) {
      var scale   = parseFloat(card.dataset[zoneKey + 'Scale']   || '1');
      var rotated = card.dataset[zoneKey + 'Rotated'] === 'true';
      var boxW    = Math.round((rotated ? bh : bw) * scale);
      var boxH    = Math.round((rotated ? bw : bh) * scale);
      var cx      = bl + bw / 2;
      var cy      = bt + bh / 2;
      overlay.style.left            = cx + 'px';
      overlay.style.top             = cy + 'px';
      overlay.style.width           = boxW + 'px';
      overlay.style.height          = boxH + 'px';
      overlay.style.transformOrigin = '50% 50%';
      overlay.style.transform       = 'translate(-50%,-50%)' + (rotated ? ' rotate(90deg)' : '');
    }

    function positionBoundary(card) {
      var boundary = card.querySelector('.cbv3-boundary');
      var img      = card.querySelector('.cbv3-card__img');
      if (!boundary || !img) return;

      var tag    = card.dataset.sizetag || '';
      var isBag  = BAG_TAGS.indexOf(tag) !== -1;
      var tab    = card.querySelector('.cbv3-zone-tab.is-active');
      var zone   = tab ? tab.dataset.zone : 'front';
      var dims   = null;

      if (isBag) {
        var entry = BAG_DIMS[tag];
        dims = entry ? (entry[zone] || entry.front || entry.back) : null;
      } else {
        dims = BOTTLE_DIMS[tag] || BOTTLE_DIMS['950ml'];
      }

      if (!dims) { boundary.style.display = 'none'; return; }

      var content = getImgContent(img);
      if (!content) { boundary.style.display = 'none'; return; }

      var iw = content.width, ih = content.height;
      var pad = 16; // 1rem
      var bw = iw * dims.w;
      var bh = ih * dims.h;
      var bl = pad + content.left + (dims.l !== undefined ? iw * dims.l : (iw - bw) / 2);
      var bt = pad + content.top  + ih * dims.t;

      boundary.style.display = 'block';
      boundary.style.left    = bl + 'px';
      boundary.style.top     = bt + 'px';
      boundary.style.width   = bw + 'px';
      boundary.style.height  = bh + 'px';

      var overlay = card.querySelector('.cbv3-logo-overlay');
      if (overlay) {
        var zoneDataKey = zone === 'front' ? 'zone1' : 'zone2';
        var logoSlot    = card.dataset[zoneDataKey + 'Logo'] || 'none';
        var logo        = (logoSlot !== 'none') ? studioLogos[logoSlot] : null;
        boundary.classList.toggle('cbv3-boundary--filled', !!logo);
        if (logo) {
          var finBtn   = document.querySelector('.cbv3-finish-btn.is-selected');
          var finish   = finBtn ? finBtn.dataset.finish : 'uv';
          var cacheKey = finish === 'metallic' ? 'cachedMetallic' : 'cachedUv';
          function applyToOverlay(url) {
            logo[cacheKey]        = url;
            overlay.src           = url;
            overlay.style.display = 'block';
            positionOverlay(card, zoneDataKey, overlay, bl, bt, bw, bh);
          }
          if (logo[cacheKey]) {
            overlay.src           = logo[cacheKey];
            overlay.style.display = 'block';
            positionOverlay(card, zoneDataKey, overlay, bl, bt, bw, bh);
          } else if (finish === 'metallic') {
            logo.mimeType === 'image/svg+xml'
              ? applyToOverlay(logo.dataUrl)
              : applyMetallicEffect(logo.dataUrl, applyToOverlay);
          } else {
            applyUVEffect(logo.dataUrl, logo.mimeType, applyToOverlay);
          }
        } else {
          overlay.style.display = 'none';
          overlay.src           = '';
        }
      }
    }

    function updateBoundary() {
      var active = document.querySelector('.cbv3-card.is-active');
      if (!active) return;
      var img = active.querySelector('.cbv3-card__img');
      if (img && img.complete && img.naturalWidth) {
        positionBoundary(active);
      } else if (img) {
        img.addEventListener('load', function () { positionBoundary(active); }, { once: true });
      }
    }

    function updateCardVariantChip(card) {
      var chip = card.querySelector('[data-card-variant]');
      if (!chip) return;
      var activeSwatch = card.querySelector('.cbv3-swatch.is-active');
      if (!activeSwatch) { chip.hidden = true; return; }
      var dot  = chip.querySelector('.cbv3-card__variant-dot');
      var name = chip.querySelector('.cbv3-card__variant-name');
      if (dot) dot.setAttribute('style', activeSwatch.getAttribute('style') || '');
      if (name) name.textContent = activeSwatch.title || '';
      chip.hidden = false;
    }

    var allCards   = Array.from(document.querySelectorAll('.cbv3-card'));
    allCards.forEach(updateCardVariantChip);
    var finishBtns = document.querySelectorAll('.cbv3-finish-btn');
    var prevBtn    = document.querySelector('.cbv3-nav--prev');
    var nextBtn    = document.querySelector('.cbv3-nav--next');
    var controlsEl = document.querySelector('.cbv3-product-controls');
    var carouselEl = document.querySelector('.cbv3-carousel');
    var visible    = allCards.slice();
    var current    = 0;
    // Tied to the card (not the stage) so neighbours hug the active card and
    // peek ~half from behind it, instead of drifting to the far stage edges.
    // Keep the formula in sync with the .cbv3-card width: min(380px, 80vw).
    function getStep() {
      var cardW = Math.min(380, window.innerWidth * 0.8);
      return Math.round(cardW * 0.52);
    }

    function updateControls(card) {
      if (!controlsEl || !card) return;
      controlsEl.innerHTML = '';

      var titleEl       = document.getElementById('cbv3-active-product-title');
      var learnMoreEl   = document.getElementById('cbv3-active-product-learn-more');
      var activeSwatch  = card.querySelector('.cbv3-swatch.is-active');
      var activeColour  = activeSwatch ? activeSwatch.title : '';
      if (titleEl) titleEl.textContent = card.dataset.title + (activeColour ? ' · ' + activeColour : '');
      if (learnMoreEl) learnMoreEl.href = card.dataset.url || '#';

      var hintEl = document.getElementById('cbv3-panel-qty-hint');
      var moq = parseInt(card.dataset.moq, 10) || 1;
      var tier1Pct = parseFloat(card.dataset.priceTier1Pct) || 0;
      // Bags start below the first discount tier: say where it starts
      var tier1From = checkoutTier1Min(card.dataset.sizetag);
      var fromNote = (moq < tier1From && tier1Pct > 0 && card.dataset.isCobrand !== 'true')
        ? ' · ' + tier1Pct + '% off from ' + tier1From : '';
      if (hintEl) hintEl.textContent = (customerType === 'wholesale'
        ? 'Min. ' + moq + ' per size, mix colours'
        : 'Min. ' + moq + ' per colour') + fromNote;

      // ── Logo zone assignment (whenever at least 1 logo is uploaded) ──────────
      var uploadedSlots = ['a', 'b'].filter(function (s) { return studioLogos[s] !== null; });
      if (uploadedSlots.length > 0) {
        var zone1name = card.dataset.zone1;
        var zone2name = card.dataset.zone2;
        var assignZones = [];
        if (zone1name) assignZones.push({ key: 'zone1', label: zone1name.toUpperCase() });
        if (zone2name) assignZones.push({ key: 'zone2', label: zone2name.toUpperCase() });
        if (assignZones.length > 0) {
          var assignWrap = document.createElement('div');
          assignWrap.className = 'cbv3-logo-assign';
          assignZones.forEach(function (zone) {
            var cur = card.dataset[zone.key + 'Logo'];
            if (!cur || (cur !== 'none' && studioLogos[cur] === null)) {
              cur = zone.key === 'zone1' ? uploadedSlots[0] : (uploadedSlots.length > 1 ? uploadedSlots[1] : uploadedSlots[0]);
              card.dataset[zone.key + 'Logo'] = cur;
            }

            var zoneBlock = document.createElement('div');
            zoneBlock.className = 'cbv3-logo-assign-zone';

            // ── Assignment row ──────────────────────────────────────────────
            var aRow = document.createElement('div');
            aRow.className = 'cbv3-logo-assign-row';
            var lbl = document.createElement('span');
            lbl.className = 'cbv3-logo-assign-label';
            lbl.textContent = zone.label + ':';
            aRow.appendChild(lbl);
            uploadedSlots.forEach(function (slot) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'cbv3-logo-assign-btn' + (cur === slot ? ' is-selected' : '');
              btn.textContent = 'Logo ' + slot.toUpperCase();
              btn.addEventListener('click', function () {
                aRow.querySelectorAll('.cbv3-logo-assign-btn').forEach(function (b) { b.classList.remove('is-selected'); });
                btn.classList.add('is-selected');
                card.dataset[zone.key + 'Logo'] = slot;
                positionBoundary(card);
                refreshPanelPrice(card);
              });
              aRow.appendChild(btn);
            });
            var noneBtn = document.createElement('button');
            noneBtn.type = 'button';
            noneBtn.className = 'cbv3-logo-assign-btn' + (cur === 'none' ? ' is-selected' : '');
            noneBtn.textContent = 'No logo';
            noneBtn.addEventListener('click', function () {
              aRow.querySelectorAll('.cbv3-logo-assign-btn').forEach(function (b) { b.classList.remove('is-selected'); });
              noneBtn.classList.add('is-selected');
              card.dataset[zone.key + 'Logo'] = 'none';
              positionBoundary(card);
              refreshPanelPrice(card);
            });
            aRow.appendChild(noneBtn);
            zoneBlock.appendChild(aRow);

            // ── Transform controls (scale 50-100% + 90° rotate toggle) ────
            var tRow = document.createElement('div');
            tRow.className = 'cbv3-logo-transform';

            // Scale custom slider 50–100% (matches b2b_upload_customizer)
            var scGrp = document.createElement('div');
            scGrp.className = 'cbv3-logo-transform-group';
            var scLbl = document.createElement('span');
            scLbl.className = 'cbv3-logo-transform-label';
            scLbl.textContent = 'Scale';
            var scTrack = document.createElement('div');
            scTrack.className = 'cbv3-scale-track';
            var scFill  = document.createElement('div');
            scFill.className = 'cbv3-scale-fill';
            var scThumb = document.createElement('div');
            scThumb.className = 'cbv3-scale-thumb';
            scTrack.appendChild(scFill);
            scTrack.appendChild(scThumb);
            var scVal = document.createElement('span');
            scVal.className = 'cbv3-logo-transform-value';

            function setScale(pct, _retry) {
              var trackW = scTrack.offsetWidth;
              if (!trackW) {
                if ((_retry || 0) < 8) requestAnimationFrame(function () { setScale(pct, (_retry || 0) + 1); });
                return;
              }
              var rawPct   = (pct - 50) / 50;
              var leftPx   = 9 + rawPct * (trackW - 18);
              scThumb.style.left = leftPx + 'px';
              scFill.style.width = (leftPx / trackW * 100).toFixed(1) + '%';
              card.dataset[zone.key + 'Scale'] = (pct / 100).toString();
              scVal.textContent = pct + '%';
              var ov = card.querySelector('.cbv3-logo-overlay');
              var bd = card.querySelector('.cbv3-boundary');
              if (ov && ov.style.display !== 'none' && bd) {
                positionOverlay(card, zone.key, ov,
                  parseFloat(bd.style.left), parseFloat(bd.style.top),
                  parseFloat(bd.style.width), parseFloat(bd.style.height));
              }
            }

            function scCalcPct(clientX) {
              var rect = scTrack.getBoundingClientRect();
              var raw  = Math.max(0, Math.min(1, (clientX - rect.left - 9) / (rect.width - 18)));
              return Math.round(50 + raw * 50);
            }

            scTrack.addEventListener('pointerdown', function (e) {
              e.preventDefault();
              setScale(scCalcPct(e.clientX));
              function onMove(ev) { setScale(scCalcPct(ev.clientX)); }
              function onUp()     { document.removeEventListener('pointermove', onMove); document.removeEventListener('pointerup', onUp); }
              document.addEventListener('pointermove', onMove);
              document.addEventListener('pointerup', onUp);
            });
            scThumb.addEventListener('pointerdown', function (e) {
              e.preventDefault(); e.stopPropagation();
              function onMove(ev) { setScale(scCalcPct(ev.clientX)); }
              function onUp()     { document.removeEventListener('pointermove', onMove); document.removeEventListener('pointerup', onUp); }
              document.addEventListener('pointermove', onMove);
              document.addEventListener('pointerup', onUp);
            });

            var scInitPct = Math.round(parseFloat(card.dataset[zone.key + 'Scale'] || '1') * 100);
            scInitPct = Math.max(50, Math.min(100, scInitPct));
            setScale(scInitPct);

            scGrp.appendChild(scLbl); scGrp.appendChild(scTrack); scGrp.appendChild(scVal);
            tRow.appendChild(scGrp);

            // Rotate 90° toggle
            var rotGrp = document.createElement('div');
            rotGrp.className = 'cbv3-logo-transform-group';
            var rotBtn = document.createElement('button');
            rotBtn.type = 'button';
            rotBtn.className = 'cbv3-logo-rotate-btn' + (card.dataset[zone.key + 'Rotated'] === 'true' ? ' is-active' : '');
            rotBtn.innerHTML = '&#x21BB;&nbsp;90&deg;';
            rotBtn.addEventListener('click', function () {
              var isRotated = card.dataset[zone.key + 'Rotated'] === 'true';
              card.dataset[zone.key + 'Rotated'] = isRotated ? 'false' : 'true';
              rotBtn.classList.toggle('is-active', !isRotated);
              var ov = card.querySelector('.cbv3-logo-overlay');
              var bd = card.querySelector('.cbv3-boundary');
              if (ov && ov.style.display !== 'none' && bd) {
                positionOverlay(card, zone.key, ov,
                  parseFloat(bd.style.left), parseFloat(bd.style.top),
                  parseFloat(bd.style.width), parseFloat(bd.style.height));
              }
            });
            rotGrp.appendChild(rotBtn);
            tRow.appendChild(rotGrp);

            zoneBlock.appendChild(tRow);

            assignWrap.appendChild(zoneBlock);
          });
          controlsEl.appendChild(assignWrap);
        }
      }

      // ── Zone tabs + colour swatches in a shared row ─────────────────────────
      var srcZones    = card.querySelectorAll('.cbv3-zone-tabs .cbv3-zone-tab');
      var srcSwatches = card.querySelectorAll('.cbv3-swatches .cbv3-swatch');

      if (srcZones.length > 1 || srcSwatches.length > 0) {
        var ctrlRow = document.createElement('div');
        ctrlRow.className = 'cbv3-controls-row';

        if (srcZones.length > 1) {
          var zonesWrap = document.createElement('div');
          zonesWrap.className = 'cbv3-zone-tabs';
          srcZones.forEach(function (orig) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = orig.className;
            btn.dataset.zone = orig.dataset.zone;
            btn.textContent = orig.textContent.trim();
            btn.addEventListener('click', function () {
              zonesWrap.querySelectorAll('.cbv3-zone-tab').forEach(function (t) { t.classList.remove('is-active'); });
              btn.classList.add('is-active');
              card.querySelectorAll('.cbv3-zone-tab').forEach(function (t) { t.classList.remove('is-active'); });
              var origMatch = card.querySelector('.cbv3-zone-tab[data-zone="' + btn.dataset.zone + '"]');
              if (origMatch) origMatch.classList.add('is-active');
              var img = card.querySelector('.cbv3-card__img');
              img.src = btn.dataset.zone === 'front' ? card.dataset.front : card.dataset.back;
              if (img.complete && img.naturalWidth) { positionBoundary(card); }
              else { img.addEventListener('load', function () { positionBoundary(card); }, { once: true }); }
            });
            zonesWrap.appendChild(btn);
          });
          ctrlRow.appendChild(zonesWrap);
        }

        if (srcSwatches.length > 0) {
          var swatchesWrap = document.createElement('div');
          swatchesWrap.className = 'cbv3-swatches';
          srcSwatches.forEach(function (orig, idx) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = orig.className;
            btn.dataset.front = orig.dataset.front;
            btn.dataset.back  = orig.dataset.back;
            btn.dataset.color = orig.dataset.color;
            btn.setAttribute('style', orig.getAttribute('style') || '');
            btn.title = orig.title;
            btn.setAttribute('aria-label', orig.getAttribute('aria-label') || '');
            btn.addEventListener('click', function () {
              swatchesWrap.querySelectorAll('.cbv3-swatch').forEach(function (s) { s.classList.remove('is-active'); });
              btn.classList.add('is-active');
              var origSwatches = card.querySelectorAll('.cbv3-swatch');
              origSwatches.forEach(function (s) { s.classList.remove('is-active'); });
              if (origSwatches[idx]) origSwatches[idx].classList.add('is-active');
              card.dataset.front = btn.dataset.front;
              card.dataset.back  = btn.dataset.back;
              var activeZone = ctrlRow.querySelector('.cbv3-zone-tab.is-active');
              var zone = activeZone ? activeZone.dataset.zone : 'front';
              var img = card.querySelector('.cbv3-card__img');
              img.src = zone === 'front' ? btn.dataset.front : btn.dataset.back;
              if (img.complete && img.naturalWidth) { positionBoundary(card); }
              else { img.addEventListener('load', function () { positionBoundary(card); }, { once: true }); }

              var activeTitleEl = document.getElementById('cbv3-active-product-title');
              if (activeTitleEl) activeTitleEl.textContent = card.dataset.title + (btn.title ? ' · ' + btn.title : '');
              updateCardVariantChip(card);
            });
            swatchesWrap.appendChild(btn);
          });
          ctrlRow.appendChild(swatchesWrap);
        }

        controlsEl.appendChild(ctrlRow);
      }

      // Runs last — zone/logo assignment defaults above must be settled first,
      // otherwise countConfiguredSides() (used by the price estimate) reads
      // unset dataset attributes and the engraving price is missing on the
      // very first render of a card.
      setPanelQty(card, moq);
    }

    function render() {
      var n    = visible.length;
      var step = getStep();
      allCards.forEach(function (c) {
        c.style.display  = 'none';
        c.style.opacity  = '0';
        c.style.zIndex   = '0';
        c.classList.remove('is-active');
      });
      visible.forEach(function (card, i) {
        var pos    = i - current;
        pos = ((pos % n) + n) % n;
        if (pos > Math.floor(n / 2)) pos -= n;
        var absPos = Math.abs(pos);
        if (absPos > 1) return; // active + immediate neighbours only
        var scale   = absPos === 0 ? 1 : 0.62;
        var opacity = absPos === 0 ? 1 : 0.55;
        card.style.display   = 'block';
        card.style.transform = 'translateX(' + (pos * step) + 'px) scale(' + scale + ')';
        card.style.opacity   = opacity;
        card.style.zIndex    = 10 - absPos;
        if (absPos === 0) { card.classList.add('is-active'); updateControls(card); }
      });
      updateBoundary();
    }

    function navigate(dir) {
      if (!visible.length) return;
      current = ((current + dir) % visible.length + visible.length) % visible.length;
      render();
    }

    function applyFinish(finish) {
      visible = allCards.filter(function (c) {
        var finishes = c.dataset.finishes;
        return !finishes || finishes.split(',').indexOf(finish) !== -1;
      });
      current = 0;
      render();
    }

    prevBtn.addEventListener('click', function () { navigate(-1); });
    nextBtn.addEventListener('click', function () { navigate(1); });

    allCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = visible.indexOf(card);
        if (idx === -1) return;
        current = idx;
        render();
      });

      card.querySelectorAll('.cbv3-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.stopPropagation();
          card.querySelectorAll('.cbv3-swatch').forEach(function (s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');
          card.dataset.front = swatch.dataset.front;
          card.dataset.back  = swatch.dataset.back;
          var activeZone = card.querySelector('.cbv3-zone-tab.is-active');
          var zone = activeZone ? activeZone.dataset.zone : 'front';
          var img  = card.querySelector('.cbv3-card__img');
          img.src  = zone === 'front' ? swatch.dataset.front : swatch.dataset.back;
          if (card.classList.contains('is-active')) {
            if (img.complete && img.naturalWidth) {
              positionBoundary(card);
            } else {
              img.addEventListener('load', function () { positionBoundary(card); }, { once: true });
            }
          }
        });
      });

      card.querySelectorAll('.cbv3-zone-tab').forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.stopPropagation();
          card.querySelectorAll('.cbv3-zone-tab').forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');
          var img = card.querySelector('.cbv3-card__img');
          img.src = tab.dataset.zone === 'front' ? card.dataset.front : card.dataset.back;
          if (card.classList.contains('is-active')) {
            if (img.complete && img.naturalWidth) {
              positionBoundary(card);
            } else {
              img.addEventListener('load', function () { positionBoundary(card); }, { once: true });
            }
          }
        });
      });
    });

    finishBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        finishBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        applyFinish(btn.dataset.finish);
        renderAllFinishPreviews();
      });
    });

    // Tab navigation
    var studioTabs   = document.querySelectorAll('.cbv3-tab');
    var studioPanels = document.querySelectorAll('.cbv3-panel');
    studioTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;
        studioTabs.forEach(function (t) { t.classList.remove('is-active'); });
        studioPanels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = document.querySelector('.cbv3-panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
        if (target === 'product') { render(); }
        // Selection thumbs are JS-positioned from the thumb's pixel size, which is 0
        // while the panel is hidden — re-render now that it's visible so logos place.
        if (target === 'selection') { renderSelection(); }
      });
    });

    // ── Logo strip and tab completion ────────────────────────────
    function updateLogoStrip() {
      ['a', 'b'].forEach(function (slot) {
        var thumb = document.getElementById('cbv3-strip-thumb-' + slot);
        if (!thumb) return;
        var logo = studioLogos[slot];
        if (logo) {
          thumb.innerHTML = '<img class="cbv3-logo-strip__img" src="' + logo.dataUrl + '" alt="">';
        } else {
          thumb.innerHTML = '<span class="cbv3-logo-strip__empty">—</span>';
        }
      });
      var hasAny = studioLogos.a || studioLogos.b;
      var hint = document.getElementById('cbv3-strip-hint');
      var edit = document.getElementById('cbv3-strip-edit');
      if (hint) hint.textContent = hasAny ? 'Logos ready' : 'No logos uploaded yet';
      if (edit) edit.textContent = hasAny ? 'Edit logos' : 'Upload logos';
    }

    function updateTabCompletion() {
      var logoTab = document.querySelector('.cbv3-tab[data-tab="logo"]');
      if (!logoTab) return;
      var hasLogo = studioLogos.a || studioLogos.b;
      logoTab.classList.toggle('is-done', !!hasLogo);
    }

    // ── Next-tab buttons (Logo "Next" nudge + strip "Edit logos" link) ───
    document.querySelectorAll('[data-next-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetTab = document.querySelector('.cbv3-tab[data-tab="' + btn.dataset.nextTab + '"]');
        if (targetTab) targetTab.click();
      });
    });

    // ── Selection (pre-cart) ────────────────────────────────────────────────
    // Local staging list. Editable here because the Shopify cart is not. Persisted
    // so it survives reloads and the future login redirect. Phase 2 maps each item
    // to the B2B cart payload (schemas/b2b-payload.schema.json) behind the auth gate.
    var SELECTION_KEY = 'tap_cobrand_selection_v2';
    var selection = [];
    var uidSeq = 0;
    var editingUid = null;  // when set, the next "Add" updates this line instead of creating one
    try { selection = JSON.parse(localStorage.getItem(SELECTION_KEY)) || []; } catch (e) { selection = []; }
    if (!Array.isArray(selection)) selection = [];

    function saveSelection() {
      try { localStorage.setItem(SELECTION_KEY, JSON.stringify(selection)); } catch (e) {}
    }

    function flashAddMsg(msg, isError) {
      // Kegan 28 Aug: after any successful add, surface the path to checkout —
      // the Selection tab was too hard to find.
      var go = document.getElementById('cbv3-goto-selection');
      if (go && !isError) go.hidden = false;
      var el = document.getElementById('cbv3-add-msg');
      if (!el) return;
      el.textContent = msg;
      el.classList.toggle('is-error', !!isError);
      el.classList.add('is-visible');
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2400);
    }

    // Read the currently-active product card into a selection item.
    // zone1 -> FRONT, zone2 -> BACK (the surfaces the B2B payload contract uses).
    function readCardConfig(card) {
      if (!card) return null;
      var activeSwatch = card.querySelector('.cbv3-swatch.is-active');
      var variantId = activeSwatch ? activeSwatch.dataset.variantId : card.dataset.variantId;
      var colorName = activeSwatch ? (activeSwatch.title || '') : '';
      var finishBtn = document.querySelector('.cbv3-finish-btn.is-selected');
      var finish = finishBtn ? finishBtn.dataset.finish : 'uv';
      var moq = parseInt(card.dataset.moq, 10) || 1;

      var zones = {};
      [['zone1', 'front'], ['zone2', 'back']].forEach(function (pair) {
        var zk = pair[0], side = pair[1];
        var zoneName = card.dataset[zk];
        if (!zoneName) return;
        var slot = card.dataset[zk + 'Logo'];
        if (!slot || slot === 'none') return;
        var logo = studioLogos[slot];
        if (!logo) return;
        zones[side] = {
          zoneName: zoneName,
          logoSlot: slot,
          logoCdnUrl: logo.cdnUrl || '',                                 // never the bare filename
          logoImg: logo.previewable === false ? '' : (logo.cdnUrl || logo.dataUrl), // for the preview thumbnail
          previewable: logo.previewable !== false,                       // false for PDF, AI, EPS
          fileType: logo.kind || '',
          productImg: side === 'front' ? card.dataset.front : card.dataset.back,
          scale: parseFloat(card.dataset[zk + 'Scale'] || '1'),
          rotated: card.dataset[zk + 'Rotated'] === 'true'
        };
      });

      return {
        handle: card.dataset.handle,
        variantId: variantId,
        surchargeId: card.dataset.surchargeId || '',
        surchargePrice: card.dataset.surchargePrice || '',
        productTitle: card.dataset.title || card.dataset.handle,
        sizetag: card.dataset.sizetag,
        color: colorName,
        finish: finish,
        moq: moq,
        quantity: moq,
        zones: zones,
        dtcPrice: parseFloat(card.dataset.dtcPrice) || 0,
        priceTier1Max: parseInt(card.dataset.priceTier1Max, 10) || 0,
        priceTier1Pct: parseFloat(card.dataset.priceTier1Pct) || 0,
        priceTier2Pct: parseFloat(card.dataset.priceTier2Pct) || 0,
        isCobrand: card.dataset.isCobrand === 'true'
      };
    }

    function getZoneDims(sizetag, side) {
      var tag = sizetag || '';
      if (BAG_TAGS.indexOf(tag) !== -1) {
        var entry = BAG_DIMS[tag];
        return entry ? (entry[side] || entry.front || entry.back) : null;
      }
      return BOTTLE_DIMS[tag] || BOTTLE_DIMS['950ml'];
    }

    // Recomposes the product photo + positioned logo as a flat PNG — same
    // ratios/scale/rotation as the on-screen boundary box (positionBoundary),
    // but on a natural-resolution offscreen canvas instead of a DOM overlay,
    // so it survives after the buyer's browser tab closes. The product image
    // needs crossOrigin='anonymous' or the canvas comes back tainted (blocks
    // toDataURL) — the logo itself is already a same-origin data: URL
    // (FileReader / the metallic/UV canvas effects), so no CORS risk there.
    function composeZonePreview(zoneCfg, sizetag, side, finish) {
      return new Promise(function (resolve) {
        var dims = getZoneDims(sizetag, side);
        if (!dims || !zoneCfg.productImg) { resolve(null); return; }

        var prodImg = new Image();
        prodImg.crossOrigin = 'anonymous';
        prodImg.onload = function () {
          var iw = prodImg.naturalWidth, ih = prodImg.naturalHeight;
          if (!iw || !ih) { resolve(null); return; }
          var canvas = document.createElement('canvas');
          canvas.width  = iw;
          canvas.height = ih;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(prodImg, 0, 0, iw, ih);

          var bw = iw * dims.w, bh = ih * dims.h;
          var bl = dims.l !== undefined ? iw * dims.l : (iw - bw) / 2;
          var bt = ih * dims.t;

          function done() {
            try { resolve(canvas.toDataURL('image/png')); }
            catch (e) { resolve(null); } // tainted canvas (CORS) — skip rather than throw
          }

          var logo     = studioLogos[zoneCfg.logoSlot];
          var cacheKey = finish === 'metallic' ? 'cachedMetallic' : 'cachedUv';
          var logoSrc  = (logo && (logo[cacheKey] || logo.dataUrl)) || zoneCfg.logoImg;
          if (!logoSrc) { done(); return; }

          var logoImg = new Image();
          logoImg.onload = function () {
            var scale   = zoneCfg.scale || 1;
            var rotated = !!zoneCfg.rotated;
            var boxW    = (rotated ? bh : bw) * scale;
            var boxH    = (rotated ? bw : bh) * scale;
            ctx.save();
            ctx.translate(bl + bw / 2, bt + bh / 2);
            if (rotated) ctx.rotate(Math.PI / 2);
            ctx.drawImage(logoImg, -boxW / 2, -boxH / 2, boxW, boxH);
            ctx.restore();
            done();
          };
          logoImg.onerror = function () { done(); };
          logoImg.src = logoSrc;
        };
        prodImg.onerror = function () { resolve(null); };
        prodImg.src = zoneCfg.productImg;
      });
    }

    function uploadPreviewImage(dataUrl, filename) {
      if (!dataUrl) return Promise.resolve('');
      return postToWorker(filename, dataUrl).catch(function () { return ''; });
    }

    // Fire-and-forget from addCurrentToSelection so the compose+upload round
    // trip never blocks the click — fills in zones[side].previewCdnUrl on the
    // matching selection line once it resolves (buildCartItems/the quote form
    // both read it whenever they happen to run next).
    function generateZonePreviews(cfg) {
      ['front', 'back'].forEach(function (side) {
        var z = cfg.zones[side];
        if (!z) return;
        // PDF/AI/EPS: no mockup. The Co-Brand Hub shows _B2B <ZONE> PREVIEW as
        // "client approved, print exactly this", and it would only show the placeholder.
        if (z.previewable === false) return;
        composeZonePreview(z, cfg.sizetag, side, cfg.finish)
          .then(function (dataUrl) {
            if (!dataUrl) return '';
            return uploadPreviewImage(dataUrl, buildPreviewFilename(side));
          })
          .then(function (url) {
            if (!url) return;
            var target = selection.filter(function (s) { return s.uid === cfg.uid; })[0];
            if (target && target.zones[side]) {
              target.zones[side].previewCdnUrl = url;
              saveSelection();
            }
          });
      });
    }

    // Estimated unit price for a line at its current quantity — display only,
    // the cobrand-tiered-discount Function sets the real charge at checkout.
    // dtcPrice is in the shop's smallest currency unit (cents); returns null
    // when no tiered pricing is configured for this line's product class.
    // Gated on tier 2 %, not tier 1 — tier 1 is legitimately 0% for cobrand company
    // customers (their tier 1 price is the B2B catalog price as-is, no extra discount),
    // so tier 1 being falsy must not hide pricing entirely. Pricing is only "not
    // configured for this class" when tier 2 is also unset.
    // Mirrors the real math in cobrand-tiered-discount (theaussiepal-functions repo) —
    // the Shopify Function that actually sets the checkout price. Single source of
    // truth for the panel price, the Selection line price, and the footer total.
    //
    // Non-cobrand: the tier % applies directly to the DTC price at both tiers.
    // Cobrand company customers already see their B2B catalog price wherever Liquid
    // renders a price (dtcPrice here, despite the name, IS that catalog price for
    // them) — the price list already put them at tier 1, so tier 2 needs the same
    // "top-up" the Function applies on top of the already-discounted price:
    // 1 - (1-tier2Pct/100)/(1-tier1Pct/100), not tier2Pct applied directly.
    // Checkout gives co-brand tier 1 from 12 of one variant, and bags from 8
    // (cobrand-tiered-discount Function: tier1MinQuantity 12, bagTier1MinQuantity 8,
    // Kegan 4 Oct 2026). Partners are unaffected: their price list already holds
    // the tier-1 price at any quantity.
    var CHECKOUT_TIER1_MIN = 12;
    var CHECKOUT_BAG_TIER1_MIN = 8;
    function checkoutTier1Min(sizetag) {
      return BAG_TAGS.indexOf(sizetag || '') !== -1 ? CHECKOUT_BAG_TIER1_MIN : CHECKOUT_TIER1_MIN;
    }

    function tierPricing(input) {
      var catalogUnit = input.dtcPrice / 100;
      var inTier1 = input.quantity <= input.priceTier1Max;

      if (!input.isCobrand) {
        var pct = input.quantity < checkoutTier1Min(input.sizetag) ? 0 : (inTier1 ? input.priceTier1Pct : input.priceTier2Pct);
        return { catalogUnit: catalogUnit, finalUnit: catalogUnit * (1 - pct / 100), displayPct: pct };
      }
      if (inTier1) {
        return { catalogUnit: catalogUnit, finalUnit: catalogUnit, displayPct: 0 };
      }
      var tier1Pct = Math.min(input.priceTier1Pct, 99.999); // guard divide-by-zero
      var topUpPct = 100 * (1 - (100 - input.priceTier2Pct) / (100 - tier1Pct));
      return { catalogUnit: catalogUnit, finalUnit: catalogUnit * (1 - topUpPct / 100), displayPct: Math.round(topUpPct) };
    }

    function estimatedUnitPrice(item) {
      if (!item.dtcPrice || !item.priceTier2Pct) return null;
      return tierPricing(item).finalUnit;
    }

    function formatMoney(n) {
      return '$' + n.toFixed(2);
    }

    // All-in estimate for a selection line: tiered product price + per-side
    // engraving (never discounted), both per unit and for the full line.
    // Single source of truth for both the per-line price and the footer
    // total in the Selection step, so the two can't drift out of sync.
    // The Function decides the tier on the quantity of the VARIANT across every
    // co-brand line (two logos on 8 Black bags each = 16 of that variant).
    function selectionVariantQty(item) {
      var n = 0;
      selection.forEach(function (s) { if (String(s.variantId) === String(item.variantId)) n += s.quantity; });
      return Math.max(n, item.quantity);
    }

    function lineEstimate(item) {
      if (!item.dtcPrice || !item.priceTier2Pct) return null;
      var priced       = tierPricing(Object.assign({}, item, { quantity: selectionVariantQty(item) }));
      var productUnit  = priced.finalUnit;
      var pct          = priced.displayPct;
      var sides        = Object.keys(item.zones).length;
      var perSidePrice = parseFloat(item.surchargePrice) || 0;
      var engravingUnit = perSidePrice * sides;
      return {
        bottleUnit: productUnit,
        pct: pct,
        perSidePrice: perSidePrice,
        sides: sides,
        unit: productUnit + engravingUnit,
        engravingUnit: engravingUnit,
        lineTotal: (productUnit + engravingUnit) * item.quantity,
        engravingTotal: engravingUnit * item.quantity
      };
    }

    // Sides currently configured with an assigned logo — mirrors the zones
    // condition in readCardConfig, needed here to add the per-side engraving
    // surcharge into the displayed estimate (it's easy to forget and it
    // matters: it's charged on every unit, tier discount or not).
    function countConfiguredSides(card) {
      var n = 0;
      ['zone1', 'zone2'].forEach(function (zk) {
        if (!card.dataset[zk]) return;
        var slot = card.dataset[zk + 'Logo'];
        if (slot && slot !== 'none' && studioLogos[slot]) n++;
      });
      return n;
    }

    // The tier % is off the bottle/bag/stubby price ONLY — engraving is a flat
    // per-side charge that's never discounted. Shown as two separate additive
    // lines (never blended into one before/after) so that's never ambiguous.
    function updatePanelPrice(card, qty) {
      var wrap   = document.getElementById('cbv3-panel-price');
      var dtcEl  = document.getElementById('cbv3-panel-price-dtc');
      var discEl = document.getElementById('cbv3-panel-price-discounted');
      var saveEl = document.getElementById('cbv3-panel-price-save');
      var engEl  = document.getElementById('cbv3-panel-price-engraving');
      var totEl  = document.getElementById('cbv3-panel-price-total');
      if (!wrap) return;

      var dtcPrice  = parseFloat(card.dataset.dtcPrice) || 0;
      var tier2Pct  = parseFloat(card.dataset.priceTier2Pct) || 0;
      // Gate on tier 2, not tier 1 — tier 1 is legitimately 0% for cobrand company
      // customers (their catalog price, no further discount).
      if (!dtcPrice || !tier2Pct) { wrap.hidden = true; return; }

      var priced = tierPricing({
        dtcPrice: dtcPrice,
        priceTier1Max: parseInt(card.dataset.priceTier1Max, 10) || 0,
        priceTier1Pct: parseFloat(card.dataset.priceTier1Pct) || 0,
        priceTier2Pct: tier2Pct,
        isCobrand: card.dataset.isCobrand === 'true',
        sizetag: card.dataset.sizetag,
        quantity: qty
      });
      var pct        = priced.displayPct;
      var dtcUnit    = priced.catalogUnit;
      var bottleUnit = priced.finalUnit;

      if (pct > 0) {
        if (dtcEl)  { dtcEl.textContent  = formatMoney(dtcUnit); dtcEl.hidden = false; }
        if (discEl) discEl.textContent = formatMoney(bottleUnit) + '/unit';
        if (saveEl) { saveEl.textContent = 'Save ' + pct + '% on bottle'; saveEl.hidden = false; }
      } else {
        // Cobrand tier 1: the catalog price already IS the price, nothing to compare against.
        if (dtcEl)  dtcEl.hidden  = true;
        if (discEl) discEl.textContent = formatMoney(bottleUnit) + '/unit';
        if (saveEl) saveEl.hidden = true;
      }

      var perSidePrice  = parseFloat(card.dataset.surchargePrice) || 0;
      var sides         = countConfiguredSides(card);
      var engravingUnit = perSidePrice * sides;
      var allInUnit     = bottleUnit + engravingUnit;

      if (engEl) {
        if (sides > 0) {
          engEl.textContent = '+ ' + formatMoney(perSidePrice) + '/side × ' + sides + (sides === 1 ? ' side' : ' sides') +
            ' engraving = ' + formatMoney(engravingUnit) + '/unit';
          engEl.hidden = false;
        } else {
          engEl.hidden = true;
        }
      }

      if (totEl) {
        totEl.textContent = formatMoney(allInUnit) + '/unit · ' + formatMoney(allInUnit * qty) +
          ' estimated total for ' + qty + (qty === 1 ? ' unit' : ' units');
      }
      wrap.hidden = false;
    }

    function refreshPanelPrice(card) {
      var valEl = document.getElementById('cbv3-panel-qty-val');
      updatePanelPrice(card, valEl ? (parseInt(valEl.textContent, 10) || 1) : 1);
    }

    // Qty stepper in the product-config panel — starts at MOQ, never goes below it.
    // The value shown here becomes the line's initial quantity on "Add to selection".
    // Wholesale: floors at 1 instead — the MOQ is enforced as an aggregate across
    // colours of the same size at "Send to cart" (see sizeAggregateQty / sendBtn below).
    function setPanelQty(card, qty) {
      var moq = parseInt(card.dataset.moq, 10) || 1;
      qty = Math.max(customerType === 'wholesale' ? 1 : moq, qty);
      var valEl = document.getElementById('cbv3-panel-qty-val');
      if (valEl) valEl.textContent = qty;
      updatePanelPrice(card, qty);
      return qty;
    }

    document.querySelectorAll('#cbv3-panel-qty [data-act]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = document.querySelector('.cbv3-card.is-active');
        if (!card) return;
        var valEl = document.getElementById('cbv3-panel-qty-val');
        var qty = (parseInt(valEl.textContent, 10) || 1) + (btn.dataset.act === 'inc' ? 1 : -1);
        setPanelQty(card, qty);
      });
    });

    function setAddMode() {
      var b = document.getElementById('cbv3-add-to-selection');
      if (b) b.textContent = editingUid ? 'Update selection' : 'Add to selection';
    }

    // Identity of a configured line for de-duping: everything except quantity —
    // variant (product+colour+size), finish, and per-zone logo + scale + rotation.
    function configSignature(cfg) {
      var parts = [cfg.variantId || '', cfg.finish || ''];
      ['front', 'back'].forEach(function (side) {
        var z = cfg.zones[side];
        parts.push(side + ':' + (z ? (z.logoCdnUrl + ',' + z.scale + ',' + (z.rotated ? 1 : 0)) : 'none'));
      });
      return parts.join('|');
    }

    function addCurrentToSelection() {
      var card = document.querySelector('.cbv3-card.is-active');
      var cfg = readCardConfig(card);
      if (!cfg) { flashAddMsg('Pick a product first.', true); return; }
      if (!Object.keys(cfg.zones).length) {
        flashAddMsg('Upload a logo and assign it to a zone first.', true);
        return;
      }
      var panelQtyEl = document.getElementById('cbv3-panel-qty-val');
      if (panelQtyEl) cfg.quantity = Math.max(customerType === 'wholesale' ? 1 : cfg.moq, parseInt(panelQtyEl.textContent, 10) || cfg.moq);
      if (editingUid) {
        var editIdx = -1;
        for (var i = 0; i < selection.length; i++) {
          if (selection[i].uid === editingUid) { editIdx = i; break; }
        }
        cfg.uid = editingUid;
        // cfg.quantity already comes from the panel's qty stepper (set above) — the
        // stepper is loaded with the line's saved quantity on entering edit mode
        // (see startEdit), so this picks up whatever the buyer left it at, including
        // a change made while editing.

        // If the edit makes this line identical to another, merge into that one (sum) and
        // drop the edited line — otherwise replace it in place.
        var editSig = configSignature(cfg);
        var mergeIdx = -1;
        for (var m = 0; m < selection.length; m++) {
          if (selection[m].uid !== editingUid && configSignature(selection[m]) === editSig) { mergeIdx = m; break; }
        }
        if (mergeIdx !== -1) {
          selection[mergeIdx].quantity += cfg.quantity;
          selection = selection.filter(function (s) { return s.uid !== editingUid; });
          flashAddMsg('Merged with a matching line ✓');
        } else if (editIdx !== -1) {
          selection[editIdx] = cfg;
          generateZonePreviews(cfg);
          flashAddMsg('Selection updated ✓');
        } else {
          selection.push(cfg);
          generateZonePreviews(cfg);
          flashAddMsg('Selection updated ✓');
        }
        editingUid = null;
        setAddMode();
        saveSelection();
        renderSelection();
        return;
      }
      // Same config already in the selection? Merge — sum quantities, no duplicate line.
      var sig = configSignature(cfg);
      for (var j = 0; j < selection.length; j++) {
        if (configSignature(selection[j]) === sig) {
          selection[j].quantity += cfg.quantity;
          saveSelection();
          renderSelection();
          flashAddMsg('Already in selection, quantity increased ✓');
          return;
        }
      }
      cfg.uid = 's' + Date.now().toString(36) + '-' + (uidSeq++);
      selection.push(cfg);
      generateZonePreviews(cfg);
      saveSelection();
      renderSelection();
      flashAddMsg('Added to selection ✓');
    }

    // Load a saved line back into the Product step and switch "Add" into update mode.
    // Targets the in-session case (uploaded logos still in memory); reconstructs a
    // minimal logo entry from stored URLs if a slot was lost (e.g. after a reload).
    function startEdit(item) {
      ['front', 'back'].forEach(function (side) {
        var z = item.zones[side];
        if (z && !studioLogos[z.logoSlot]) {
          studioLogos[z.logoSlot] = z.previewable === false
            ? { filename: '', dataUrl: placeholderFor(z.fileType), cdnUrl: z.logoCdnUrl || '', mimeType: 'image/svg+xml', previewable: false, kind: z.fileType || '' }
            : { filename: '', dataUrl: z.logoImg, cdnUrl: z.logoCdnUrl || '', mimeType: '' };
        }
      });
      updateLogoStrip();
      updateTabCompletion();

      var card = allCards.filter(function (c) { return c.dataset.handle === item.handle; })[0];
      if (!card) { flashAddMsg('Could not reopen this product.', true); return; }

      // Colour / variant
      if (item.variantId) {
        var sw = card.querySelector('.cbv3-swatch[data-variant-id="' + item.variantId + '"]');
        if (sw) {
          card.querySelectorAll('.cbv3-swatch').forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          card.dataset.front = sw.dataset.front;
          card.dataset.back  = sw.dataset.back;
        }
      }

      // Sync the displayed product image to the restored colour (the card may have been
      // left on a different variant), keeping whichever zone is currently in view.
      var editImg = card.querySelector('.cbv3-card__img');
      if (editImg) {
        var azt  = card.querySelector('.cbv3-zone-tab.is-active');
        var zone = azt ? azt.dataset.zone : 'front';
        editImg.src = (zone === 'back') ? card.dataset.back : card.dataset.front;
      }

      // Per-zone logo assignment + transforms
      [['zone1', 'front'], ['zone2', 'back']].forEach(function (pair) {
        var zk = pair[0], side = pair[1];
        if (!card.dataset[zk]) return;
        var z = item.zones[side];
        if (z) {
          card.dataset[zk + 'Logo']    = z.logoSlot;
          card.dataset[zk + 'Scale']   = String(z.scale != null ? z.scale : 1);
          card.dataset[zk + 'Rotated'] = z.rotated ? 'true' : 'false';
        } else {
          card.dataset[zk + 'Logo'] = 'none';
        }
      });

      // Finish (re-filters the carousel, so do it before centring)
      var finBtn = document.querySelector('.cbv3-finish-btn[data-finish="' + item.finish + '"]');
      if (finBtn) {
        finishBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        finBtn.classList.add('is-selected');
        applyFinish(item.finish);
        renderAllFinishPreviews();
      }

      var idx = visible.indexOf(card);
      if (idx !== -1) current = idx;

      editingUid = item.uid;
      setAddMode();

      var productTab = document.querySelector('.cbv3-tab[data-tab="product"]');
      if (productTab) productTab.click();  // activates panel + render()
      else render();

      // render()/updateControls() just reset the panel qty stepper to MOQ —
      // overwrite it with this line's actual saved quantity so editing starts
      // from what's really in the cart, not from the MOQ floor.
      setPanelQty(card, item.quantity);
    }

    // Logo image for a preview thumb, with the same finish effect the studio card applies
    // (metallic gradient / UV white-knockout). Pulls the raw logo from memory and reuses the
    // shared cachedMetallic/cachedUv so it matches the card; falls back to the stored URL
    // (e.g. after a reload, when the in-memory logo is gone — metallic may then be raw).
    function setThumbLogoSrc(lg, z, finish) {
      if (z.previewable === false) { lg.src = placeholderFor(z.fileType); return; }
      var logo = studioLogos[z.logoSlot];
      if (logo && logo.dataUrl) {
        var cacheKey = finish === 'metallic' ? 'cachedMetallic' : 'cachedUv';
        if (logo[cacheKey]) { lg.src = logo[cacheKey]; return; }
        var done = function (url) { logo[cacheKey] = url; lg.src = url; };
        if (finish === 'metallic') {
          logo.mimeType === 'image/svg+xml' ? done(logo.dataUrl) : applyMetallicEffect(logo.dataUrl, done);
        } else {
          applyUVEffect(logo.dataUrl, logo.mimeType, done);
        }
        return;
      }
      if (z.logoImg) lg.src = z.logoImg;
    }

    // Static product-with-logo preview for the selection list. Reuses the same
    // ratio-based placement as the studio card (BOTTLE_DIMS / BAG_DIMS), minus the
    // visible boundary box. zone1 -> front, zone2 -> back.
    function placeThumbLogo(prodImg, logoImg, side, z, sizetag) {
      function place() {
        var content = getImgContent(prodImg);
        if (!content) { logoImg.style.display = 'none'; return; }
        var tag  = sizetag || '';
        var dims = null;
        if (BAG_TAGS.indexOf(tag) !== -1) {
          var entry = BAG_DIMS[tag];
          dims = entry ? (entry[side] || entry.front || entry.back) : null;
        } else {
          dims = BOTTLE_DIMS[tag] || BOTTLE_DIMS['950ml'];
        }
        if (!dims) { logoImg.style.display = 'none'; return; }
        var iw = content.width, ih = content.height;
        var bw = iw * dims.w;
        var bh = ih * dims.h;
        var bl = content.left + (dims.l !== undefined ? iw * dims.l : (iw - bw) / 2);
        var bt = content.top  + ih * dims.t;
        var scale   = z.scale || 1;
        var rotated = !!z.rotated;
        var ow = (rotated ? bh : bw) * scale;
        var oh = (rotated ? bw : bh) * scale;
        logoImg.style.left            = (bl + bw / 2) + 'px';
        logoImg.style.top             = (bt + bh / 2) + 'px';
        logoImg.style.width           = ow + 'px';
        logoImg.style.height          = oh + 'px';
        logoImg.style.transform       = 'translate(-50%,-50%)' + (rotated ? ' rotate(90deg)' : '');
        logoImg.style.display         = 'block';
      }
      if (prodImg.complete && prodImg.naturalWidth) place();
      else prodImg.addEventListener('load', place, { once: true });
    }

    // Wholesale only: total quantity across every selection line for the same
    // product (handle) — colours of one size share one product and must add
    // up to that product's MOQ, instead of each colour meeting it alone.
    function sizeAggregateQty(handle) {
      return selection.reduce(function (sum, i) {
        return i.handle === handle ? sum + i.quantity : sum;
      }, 0);
    }

    function renderSelection() {
      var listEl    = document.getElementById('cbv3-selection-list');
      var emptyEl   = document.getElementById('cbv3-selection-empty');
      var footerEl  = document.getElementById('cbv3-selection-footer');
      var countEl   = document.getElementById('cbv3-selection-total-count');
      var priceEl   = document.getElementById('cbv3-selection-total-price');
      if (!listEl) return;

      var selTab = document.querySelector('.cbv3-tab[data-tab="selection"]');
      if (selTab) {
        selTab.classList.toggle('is-done', selection.length > 0);
      }

      if (!selection.length) {
        listEl.hidden = true; listEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      listEl.hidden = false;
      if (footerEl) footerEl.hidden = false;

      listEl.innerHTML = '';
      var totalUnits    = 0;
      var grandTotal     = 0;
      var engravingTotal = 0;
      selection.forEach(function (item) {
        totalUnits += item.quantity;
        var est = lineEstimate(item);
        if (est) {
          grandTotal     += est.lineTotal;
          engravingTotal += est.engravingTotal;
        }

        var row = document.createElement('div');
        row.className = 'cbv3-sel-item';
        row.dataset.uid = item.uid;
        row.innerHTML =
          '<div class="cbv3-sel-previews"></div>' +
          '<div class="cbv3-sel-bar">' +
            '<div class="cbv3-sel-info">' +
              '<p class="cbv3-sel-title"></p>' +
              '<p class="cbv3-sel-size-status" hidden></p>' +
              '<p class="cbv3-sel-price"></p>' +
            '</div>' +
            '<button type="button" class="cbv3-sel-edit" data-act="edit">Edit</button>' +
            '<div class="cbv3-sel-qty">' +
              '<button type="button" class="cbv3-sel-qty-btn" data-act="dec" aria-label="Decrease">−</button>' +
              '<span class="cbv3-sel-qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="cbv3-sel-qty-btn" data-act="inc" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="cbv3-sel-remove" data-act="remove" aria-label="Remove">✕</button>' +
          '</div>';
        // textContent (not innerHTML) for product-supplied strings
        row.querySelector('.cbv3-sel-title').textContent = item.productTitle + (item.color ? ' · ' + item.color : '');

        // Wholesale: MOQ is an aggregate across colours of this size, not per line —
        // show progress toward it so the buyer knows what still needs topping up.
        if (customerType === 'wholesale') {
          var sizeQty = sizeAggregateQty(item.handle);
          var statusEl = row.querySelector('.cbv3-sel-size-status');
          statusEl.hidden = false;
          statusEl.classList.toggle('is-short', sizeQty < item.moq);
          statusEl.textContent = sizeQty >= item.moq
            ? '✓ ' + sizeQty + ' of ' + item.moq + ' for this size'
            : sizeQty + ' of ' + item.moq + ' for this size — add ' + (item.moq - sizeQty) + ' more (any colour)';
        }

        var linePriceEl = row.querySelector('.cbv3-sel-price');
        if (est) {
          // Structured pricing (Kegan 28 Aug): the single run-on string was
          // confusing — unit price bold, saving as a pill, engraving muted,
          // line total pulled right. All values come from formatMoney/numbers.
          var ph = '<span class="cbv3-price-unit">' + formatMoney(est.bottleUnit) + '/unit</span>';
          if (est.pct > 0) { ph += '<span class="cbv3-price-save">' + est.pct + '% off</span>'; }
          if (est.sides > 0) {
            ph += '<span class="cbv3-price-eng">+ ' + formatMoney(est.perSidePrice) + '/side × ' + est.sides + (est.sides === 1 ? ' side' : ' sides') + ' engraving</span>';
          }
          ph += '<span class="cbv3-price-total">' + formatMoney(est.lineTotal) + ' <small>estimated</small></span>';
          linePriceEl.innerHTML = ph;
        } else {
          linePriceEl.hidden = true;
        }

        // Product-with-logo previews, one per customised side (front, then back)
        var prevWrap = row.querySelector('.cbv3-sel-previews');
        ['front', 'back'].forEach(function (side) {
          var z = item.zones[side];
          if (!z) return;
          var box = document.createElement('div');
          box.className = 'cbv3-thumb';
          var prod = document.createElement('img');
          prod.className = 'cbv3-thumb-prod';
          prod.alt = '';
          var lg = document.createElement('img');
          lg.className = 'cbv3-thumb-logo';
          lg.alt = '';
          lg.setAttribute('aria-hidden', 'true');
          box.appendChild(prod);
          box.appendChild(lg);
          prevWrap.appendChild(box);
          placeThumbLogo(prod, lg, side, z, item.sizetag);
          setThumbLogoSrc(lg, z, item.finish);
          prod.src = z.productImg || '';
        });

        listEl.appendChild(row);
      });

      if (countEl) {
        countEl.textContent = selection.length + (selection.length === 1 ? ' product' : ' products') + ' · ' + totalUnits + ' units';
      }
      if (priceEl) {
        if (grandTotal > 0) {
          priceEl.innerHTML = '<strong class="cbv3-total-big">' + formatMoney(grandTotal) + '</strong><span class="cbv3-total-lab">estimated total</span>' +
            (engravingTotal > 0 ? '<span class="cbv3-total-eng">incl. ' + formatMoney(engravingTotal) + ' engraving</span>' : '');
          priceEl.hidden = false;
        } else {
          priceEl.hidden = true;
        }
      }
    }

    function findItem(uid) {
      for (var i = 0; i < selection.length; i++) { if (selection[i].uid === uid) return selection[i]; }
      return null;
    }

    var selListEl = document.getElementById('cbv3-selection-list');
    if (selListEl) {
      selListEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-act]');
        if (!btn) return;
        var rowEl = e.target.closest('.cbv3-sel-item');
        var item = rowEl && findItem(rowEl.dataset.uid);
        if (!item) return;
        if (btn.dataset.act === 'edit') { startEdit(item); return; }
        if (btn.dataset.act === 'remove') {
          selection = selection.filter(function (s) { return s.uid !== item.uid; });
          if (editingUid === item.uid) { editingUid = null; setAddMode(); }
        } else if (btn.dataset.act === 'inc') {
          item.quantity = item.quantity + 1;
        } else if (btn.dataset.act === 'dec') {
          item.quantity = Math.max(customerType === 'wholesale' ? 1 : item.moq, item.quantity - 1);
        }
        saveSelection();
        renderSelection();
      });
    }

    var addBtn = document.getElementById('cbv3-add-to-selection');
    if (addBtn) addBtn.addEventListener('click', addCurrentToSelection);
    var zoomBtn = document.getElementById('cbv3-zoom-btn');
    if (zoomBtn) zoomBtn.addEventListener('click', function () {
      var car = document.querySelector('.cbv3-carousel');
      if (!car) return;
      var on = car.classList.toggle('cbv3-zoomed');
      zoomBtn.textContent = on ? 'Close zoom' : 'Zoom logo';
      /* inline transform: a theme transition keeps the CSS rule from settling */
      car.querySelectorAll('.cbv3-card__img-wrap').forEach(function (w) { w.style.transform = ''; });
      if (on) {
        var wrap = car.querySelector('.cbv3-card.is-active .cbv3-card__img-wrap');
        if (wrap) wrap.style.transform = 'scale(1.9)';
      }
    });
    var gotoSel = document.getElementById('cbv3-goto-selection');
    if (gotoSel) gotoSel.addEventListener('click', function () {
      var selTab = document.querySelector('.cbv3-tab[data-tab="selection"]');
      if (selTab) { selTab.click(); }
      var root = document.getElementById('cobrand-studio');
      if (root && root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    function selMsg(text) {
      var msg = document.getElementById('cbv3-selection-msg');
      if (msg) msg.textContent = text || '';
    }

    // Map the selection to the B2B /cart/add.js payload (schemas/b2b-payload.schema.json).
    // Each item -> main product line + engraving-surcharge line, linked by _cust_id.
    // The real zone (front/back/top/pocket) is named in each property KEY.
    function buildCartItems() {
      var items = [];
      selection.forEach(function (item) {
        var custId = 'c' + Date.now().toString(36) + '-' + (uidSeq++);
        // _cobrand marks this line as eligible for co-brand tiered pricing (the
        // discount Function keys off it). _customised_product alone isn't enough —
        // customizer-b2b.js, customizer-dtc.js and bundy_bundle_customizer.js all set
        // it too for unrelated flows. Any future tool that should get co-brand tiers
        // must set _cobrand: 'yes' the same way.
        var props = { _customised_product: 'yes', _cobrand: 'yes', _cust_id: custId };
        if (item.moq > 1) props._moq = item.moq;

        var sides = 0;
        ['front', 'back'].forEach(function (side) {
          var z = item.zones[side];
          if (!z) return;
          var ZONE = (z.zoneName || side).toUpperCase();
          var label = item.productTitle + (item.color ? '-' + item.color : '');
          props['_B2B ' + ZONE + ' ENGRAVING']     = label;
          props['B2B ' + ZONE + ' IMAGE']          = z.logoCdnUrl;
          props['_B2B ' + ZONE + ' IMAGE ROTATED'] = z.rotated ? 'yes' : 'no';
          props['_B2B ' + ZONE + ' IMAGE SCALE']   = Math.round((z.scale || 1) * 100);
          props['B2B ' + ZONE + ' FINISH']         = item.finish;
          if (item.surchargePrice) props['_B2B ' + ZONE + ' IMAGE PRICE'] = item.surchargePrice;
          // Composed product+logo mockup (see generateZonePreviews) — may still be
          // uploading when Send to cart is clicked right after Add to selection, so
          // this is best-effort, not guaranteed present. Underscore-prefixed: staff/
          // ops reference only, not something the operator prints or acts on.
          if (z.previewCdnUrl) props['_B2B ' + ZONE + ' PREVIEW'] = z.previewCdnUrl;
          sides++;
        });

        items.push({ id: parseInt(item.variantId, 10), quantity: item.quantity, properties: props });

        if (item.surchargeId && sides > 0) {
          items.push({
            id: parseInt(item.surchargeId, 10),
            quantity: sides * item.quantity,
            properties: { '_Customised Product': 'yes', _cust_id: custId }
          });
        }
      });
      return items;
    }

    function openCartDrawer() {
      if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); return; }
      var trigger = document.querySelector('.js-drawer-open-button-right .material-icons-outlined');
      if (trigger) trigger.click();
    }

    // ── Customer type ────────────────────────────────────────────────────────
    // Every customer type (guest, noncobrand, wholesale, cobrand) can add to
    // cart. Pricing is resolved server-side: DTC + cobrand-tiered-discount
    // Function for everyone except cobrand companies, who get their B2B price
    // list plus the same Function's tier-2 top-up. customerType is only read
    // here to clear the mid-signup bookkeeping flag once it resolves.
    var studioEl     = document.getElementById('cobrand-studio');
    var customerType = (studioEl && studioEl.dataset.customerType) || 'cobrand';

    // Returned from the signup round-trip as co-brand → the Flow finished, clear the pending flag.
    if (customerType === 'cobrand') {
      try { sessionStorage.removeItem('cobrand_signup_pending'); } catch (e) {}
    }

    var sendBtn = document.getElementById('cbv3-send-to-cart');
    if (sendBtn) {
      sendBtn.addEventListener('click', function () {
        if (!selection.length) return;

        // Wholesale: every size (product handle) touched must reach its MOQ once
        // its colours are summed, even though each individual line was allowed
        // below MOQ. Block here — this is the only path into the cart from the
        // Studio, so this is the real gate, not just a UI hint.
        if (customerType === 'wholesale') {
          var seenHandles = [];
          var shortfalls = [];
          selection.forEach(function (item) {
            if (seenHandles.indexOf(item.handle) !== -1) return;
            seenHandles.push(item.handle);
            var sizeQty = sizeAggregateQty(item.handle);
            if (sizeQty < item.moq) {
              shortfalls.push(item.productTitle + ' (' + sizeQty + ' of ' + item.moq + ', add ' + (item.moq - sizeQty) + ' more)');
            }
          });
          if (shortfalls.length) {
            selMsg('Minimum not reached — mix any colours to get there: ' + shortfalls.join('; ') + '.');
            renderSelection();
            return;
          }
        }

        // Every logo on every line must be a real uploaded link. Lines saved
        // before this fix (localStorage) can still hold a bare filename.
        var notUploaded = [];
        selection.forEach(function (item) {
          var bad = Object.keys(item.zones || {}).some(function (side) {
            return !isUsableUrl(item.zones[side] && item.zones[side].logoCdnUrl);
          });
          if (bad) notUploaded.push(item.productTitle + (item.color ? ' · ' + item.color : ''));
        });
        if (notUploaded.length) {
          selMsg("A logo on " + notUploaded.join(', ') + " didn't upload, so it can't be ordered yet. Upload it again on the Logo tab, tap Edit on that line, then add it again.");
          return;
        }

        var items = buildCartItems();
        if (!items.length) return;
        sendBtn.disabled = true;
        selMsg('Adding to your cart…');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            sendBtn.disabled = false;
            if (!res.ok) { selMsg('Could not add to cart. ' + (res.body && res.body.description ? res.body.description : 'Please try again.')); return; }
            selection = [];
            saveSelection();
            renderSelection();
            selMsg('');
            openCartDrawer();
            // /cart/add.js's response is immediate — the cobrand-tiered-discount Function
            // (triggered by _cobrand) may not be fully applied yet, so the linked engraving
            // line's price can render as $0 in the drawer even though checkout is correct.
            // Re-render shortly after with a fresh /cart.js fetch once the Function has caught up.
            setTimeout(openCartDrawer, 700);
          })
          .catch(function () { sendBtn.disabled = false; selMsg('Network error. Please try again.'); });
      });
    }

    // ── "Prefer a quote?" (Lane 2 capture) ──────────────────────────────────
    // Posts to the same B2B worker as the logo uploads, on a separate /quote
    // route (existing upload behaviour untouched — see the worker repo).
    // The selection/draft is never cleared here, even on success: a buyer who
    // asks for a quote can still check out themselves if they change their mind.
    var quoteToggle = document.getElementById('cbv3-quote-toggle');
    var quotePanel  = document.getElementById('cbv3-quote');
    var quoteForm   = document.getElementById('cbv3-quote-form');
    var quoteMsg    = document.getElementById('cbv3-quote-msg');

    if (quoteToggle && quotePanel) {
      quoteToggle.addEventListener('click', function () {
        var isOpen = quotePanel.classList.toggle('is-open');
        quoteToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    if (quoteForm) {
      quoteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!selection.length) return;

        var submitBtn = document.getElementById('cbv3-quote-submit');
        var fd = new FormData(quoteForm);
        var payload = {
          name: (fd.get('name') || '').trim(),
          company: (fd.get('company') || '').trim(),
          email: (fd.get('email') || '').trim(),
          phone: (fd.get('phone') || '').trim(),
          deadline: fd.get('deadline') || '',
          notes: (fd.get('notes') || '').trim(),
          draft: selection
        };
        if (!payload.name || !payload.email) return;

        var workerUrl = window.b2bUploadWorkerUrl;
        if (!workerUrl) {
          if (quoteMsg) { quoteMsg.textContent = 'Quote requests are unavailable right now.'; quoteMsg.className = 'cbv3-quote__msg is-error'; }
          return;
        }

        submitBtn.disabled = true;
        if (quoteMsg) { quoteMsg.textContent = 'Sending…'; quoteMsg.className = 'cbv3-quote__msg'; }

        fetch(workerUrl + '/quote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            submitBtn.disabled = false;
            if (!res.ok) {
              // error may be a string or an Airtable {type,message} object (worker /quote, Sep 2026)
              var qErr = res.body && res.body.error;
              try { console.warn('[cobrand studio quote] worker error', qErr); } catch (e2) {}
              if (quoteMsg) { quoteMsg.textContent = 'Could not send just now. Email cobrand@theaussiepal.com.au and we will quote from there.'; quoteMsg.className = 'cbv3-quote__msg is-error'; }
              return;
            }
            if (quoteMsg) { quoteMsg.textContent = 'Got it — Rose will email your quote within one business day.'; quoteMsg.className = 'cbv3-quote__msg is-success'; }
            quoteForm.reset();
          })
          .catch(function () {
            submitBtn.disabled = false;
            if (quoteMsg) { quoteMsg.textContent = 'Network error. Please try again.'; quoteMsg.className = 'cbv3-quote__msg is-error'; }
          });
      });
    }

    applyFinish('uv');
    renderSelection();

    window.addEventListener('resize', render);

    // Touch swipe on carousel
    if (carouselEl) {
      var touchStartX = 0;
      carouselEl.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      carouselEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) navigate(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  })();
